import {useTranslation} from 'react-i18next';

import {Workday, WorkspaceReservation} from '@lib/store/src/data/timeslots/apiTypes';
import {timeLabel} from '@lib/store/src/data/timeslots/dateTimeHelpers';
import {trackEvent} from '@lib/infrastructure';
import {Icon} from '@atoms';
import {BookingDetailsCard} from 'src/components/organisms/bookWorkspace';
import {isGroupBooking, isOfficeWorkday} from '@lib/store/src/data/timeslots/utils';
import {useModal} from '@hooks';

interface Props {
  workday?: Workday;
  workspaceReservation: WorkspaceReservation;
  selectedDate: string;
  isLast?: boolean;
}

export const WorkspaceReservationTile = ({workday, workspaceReservation, selectedDate, isLast}: Props) => {
  const {t} = useTranslation();
  const {openModal, setModalPages} = useModal();

  const deskName = 'deskName' in workspaceReservation.workspace ? workspaceReservation.workspace.deskName : null;
  const areaName = 'areaName' in workspaceReservation.workspace ? workspaceReservation.workspace.areaName : null;
  const floorName = 'floorName' in workspaceReservation.workspace ? workspaceReservation.workspace.floorName : null;

  return (
    <button
      onClick={() => {
        if (isOfficeWorkday(workday)) {
          setModalPages([
            <BookingDetailsCard
              date={selectedDate}
              workday={workday}
              workspaceReservation={workspaceReservation}
            />,
          ]);

          openModal();

          trackEvent('CalendarOverview_BookingDetails__Open', {
            date: selectedDate,
            isGroupBooking: isGroupBooking(workspaceReservation),
          });
        }
      }}
      className={`flex flex-row gap-2 items-start px-5 py-5 text-left w-full border-b ${isLast ? 'border-b-0' : ''}`}>
      <Icon
        icon="desk"
        size="1.5rem"
      />

      <div className="ml-4 flex-1">
        {isGroupBooking(workspaceReservation) && <p>{t('workplace:GroupBooking')}</p>}

        <p className="mb-2 text-[15px] text-black">
          {timeLabel(workspaceReservation.localStart, workspaceReservation.localEnd, t)}
        </p>

        <p className="text-[15px] font-semibold text-black">{areaName}</p>

        {floorName && (
          <p className="text-[15px] font-semibold text-black">
            {floorName}
            {floorName && deskName && `, ${deskName}`}
          </p>
        )}
      </div>

      <Icon
        icon="caretRight"
        size="1.3rem"
        className="ml-auto self-center"
      />
    </button>
  );
};
